import {
    AfterContentInit,
    Component,
    EventEmitter,
    HostListener,
    Input, OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { HasPendingChangesGuard } from '../../../common/guards/has-pending-changes';

import { SessionItemRow } from '../../providers/sessionItems-provider';
import { EditableBlockInterface } from '../../editable-block-interface';
import { SessionExerciceDurationEditComponent } from './session-exercice-duration-edit';
import { Subscription } from 'rxjs';
import { Organization } from "../../../common/models/organization";
import { NgForOf, NgIf } from "@angular/common";
import { ShareComponent } from "../../../chat/share/share.component";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import {
  ExerciceCategoryThumbnailComponent
} from "../../../exercices/components/exercice-category-thumbnail/exercice-category-thumbnail";
import { ExercicesVideoButtonComponent } from "../../../exercices/components/video-button/video-button";
import { DurationVerbosePipe } from "../../../common/pipes/duration-verbose";
import { MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { ExerciceCategory } from "../../../common/models/exercice-category";
import { ConfigProvider } from "../../../config-provider.service";

@Component({
  selector: 'session-exercice-duration',
  providers: [],
  styleUrls: ['../common/session-exercice/session-exercice.scss', './session-exercice-duration.scss'],
  standalone: true,
  imports: [
    NgIf,
    ShareComponent,
    MatTooltip,
    MatIcon,
    TranslateModule,
    FlexLayoutModule,
    ExerciceCategoryThumbnailComponent,
    NgForOf,
    ExercicesVideoButtonComponent,
    DurationVerbosePipe,
    MatIconButton,
    MatMenuTrigger,
    MatMenuItem,
    MatMenu
  ],
  templateUrl: './session-exercice-duration.html'
})
export class SessionExerciceDurationComponent implements OnInit, AfterContentInit, EditableBlockInterface, OnDestroy {
    @Input() public isMobileDisplay = false;
    @Input() public basicDisplay = false;
    @Input() public organization: Organization | null = null;
    @Input() public data: SessionItemRow = {} as SessionItemRow;
    @Input() public isEditable = true;
    @Input() public itsTheFirst = false;
    @Input() public itsTheLast = false;
    @Input() public parentIndex: number | undefined;
    @Input() public stopwatchSelected = false;
    public _duration: number | null = null;
    public _restTime: number | null = null;
    public _totalTime: number | null = null;
    public totalDuration = 0;
    @Output('onTimeBasedInfoUpdated') public onTimeBasedInfoUpdated: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Output('onDelete') public onDelete: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onPersonalizedExerciceClicked') public onPersonalizedExerciceClicked: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onDuplicate') public onDuplicate: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onMoveUp') public onMoveUp: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onMoveDown') public onMoveDown: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output() public onChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output('onDuplicateAsModel') public onDuplicateAsModel: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output() public onValuesAreGood: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output() public onValuesAreNotGood: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output() public openStopwatch: EventEmitter<any> = new EventEmitter();
    public isSelected = false;
    private subscriptions: Subscription[] = [];

    constructor(
      private _utils: UtilsProvider,
      private _changesGuard: HasPendingChangesGuard,
      protected conf: ConfigProvider,
    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.onChanged.subscribe(() => {
                this.calculateDurations();
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    @HostListener('window:beforeunload')
    public doSomething() {
        return !this._changesGuard.hasChanges();
    }

    public editComponent(): any {
        return SessionExerciceDurationEditComponent;
    }

    public toggleSelected(bool: boolean): void {
        this.isSelected = bool;
    }

    public ngAfterContentInit(): void {
        this.setDefaultValues();
        this.calculateDurations();
    }

    public duplicate(toDuplicate: SessionItemRow): void {
        // set a default id other than "0" to avoid value reset. See : this.setDefaultValues()
        this.data.data.sessionItemExercice.id = -1;

        this.onDuplicate.emit(toDuplicate);
        this.onChanged.emit();
    }

    public delete(toDelete: SessionItemRow): void {
        this.onDelete.emit(toDelete);
        this.onChanged.emit();
    }

    public personalized(toPersonalized: SessionItemRow): void {
        this.onPersonalizedExerciceClicked.emit(toPersonalized);
        this.onChanged.emit();
    }

    public moveup(toMove: SessionItemRow): void {
        toMove.parentIndex = this.parentIndex??0;
        this.onMoveUp.emit(toMove);
    }

    public movedown(toMove: SessionItemRow): void {
        toMove.parentIndex = this.parentIndex??0;
        this.onMoveDown.emit(toMove);
    }

    public calculateDurations() {
        this._duration = this.data.data.sessionItemExercice.duration;
        this._restTime = this.data.data.sessionItemExercice.restTime;
        this._totalTime = (this._duration! + this._restTime!) * this.data.data.sessionItemExercice.nbRepeat;
        this.totalDuration = this._totalTime;
    }

    public duplicateAsModel(toDuplicate: SessionItemRow) {
        this.onDuplicateAsModel.emit(toDuplicate);
    }

    private setDefaultValues() {
        if (this.data.data.sessionItemExercice.id === 0) {
            this.data.data.sessionItemExercice.duration = this.data.data.exercice.exercice.duration;
            this.data.data.sessionItemExercice.nbRepeat = 1;
            this.data.data.sessionItemExercice.restTime = 0;
        }
    }

  protected readonly ExerciceCategory = ExerciceCategory;
}
